import { DataAttribution } from "./DataAttribution"
import { NormalRange } from "./NormalRange"
import styles from "./Overlay.module.scss"
import { UrgentLow } from "./UrgentLow"

export function Overlay() {
  return (
    <div className={styles.container}>
      <DataAttribution className={styles.dexcomAttribution} />
      <NormalRange className={styles.normalRange} />
      <UrgentLow className={styles.urgentLow} />
    </div>
  )
}
